import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthGroupService } from '../services/auth-group.service';

export const authGroupGuard: CanActivateFn = () => {
    const authGroupService = inject(AuthGroupService);
    const router = inject(Router);

    const account = authGroupService.getResolvedAccount();
    if (!account) {
        return router.createUrlTree(['/home']);
    }

    if (authGroupService.hasRequiredAzureGroup()) {
        return true;
    }

    return router.createUrlTree(['/unauthorized']);
};